export default __webpack_public_path__ + "static/leadership_matthew_hulett-17ff3466b32ce3cdf24495f4a4d59110.jpg";